"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const maps_1 = require("services/maps");
const api_1 = require("@react-google-maps/api");
const containerStyle = {
    width: "100%",
    height: "400px",
};
const center = {
    lat: -12.025102,
    lng: -77.034543,
};
const ModalRoadmapMap = ({ onAccept, ...rest }) => {
    const onAcceptPressed = () => {
        onAccept(address, map?.getCenter()?.lat() ?? 0, map?.getCenter()?.lng() ?? 0);
    };
    const [address, setAddress] = React.useState("");
    const [addresses, setAddresses] = React.useState();
    const [markerPosition, setMarkerPosition] = React.useState({
        lat: 0,
        lng: 0,
    });
    //other lib
    const { isLoaded } = (0, api_1.useJsApiLoader)({
        id: "google-map-script",
        googleMapsApiKey: "AIzaSyBF3E8A_OpbywwZmUcMQaQQoqX26qRjjco",
    });
    const [map, setMap] = React.useState(null);
    const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        const bounds = new window.google.maps.LatLngBounds(center);
        onChangeMarkerPosition(center);
        //map.fitBounds(bounds);
        setMap(map);
    }, []);
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
    }, []);
    const onChangeMarkerPosition = (latLng) => {
        setMarkerPosition(latLng);
        const onSuccess = (response) => {
            setAddress(response?.fullAddr ?? "");
        };
        console.log(map);
        (0, maps_1.doMapsReverse)({
            params: {
                lat: latLng?.lat?.toString(),
                lng: latLng?.lng?.toString(),
            },
            callback: {
                onSuccess,
            },
        });
    };
    const onChangeAddress = (text) => {
        setAddress(text);
        const onSuccess = (response) => {
            setAddresses(response.data);
        };
        (0, maps_1.doMapsAutocomplete)({
            params: {
                q: text,
            },
            callback: {
                onSuccess,
            },
        });
    };
    const onAddressPressed = (ad) => {
        const onSuccess = (response) => {
            setMarkerPosition({ lat: response.lat ?? 0, lng: response.lng ?? 0 });
            setAddress(ad.fullAddr ?? "");
            map?.moveCamera({
                zoom: 18,
                center: {
                    lat: response.lat ?? 0,
                    lng: response.lng ?? 0,
                },
            });
            setAddresses(undefined);
        };
        (0, maps_1.doMapsGeocoding)({
            params: {
                q: address,
                placeId: ad.placeId,
            },
            callback: {
                onSuccess,
            },
        });
    };
    const renderItem = ({ item }) => {
        return <AddressItem address={item} onPressed={onAddressPressed}/>;
    };
    return (<native_base_1.Modal {...rest} size="full" ml="0">
			<native_base_1.Modal.Content>
				<native_base_1.Modal.CloseButton />
				<native_base_1.Modal.Body h={500}>
					{isLoaded && (<native_base_1.VStack>
							<native_base_1.Input value={address} onChangeText={onChangeAddress} mt={50} mb={20}/>

							<api_1.GoogleMap mapContainerStyle={containerStyle} center={center} zoom={11} onLoad={onLoad} onUnmount={onUnmount}>
								{/* Child components, such as markers, info windows, etc. */}
								<></>
								<api_1.Marker position={markerPosition} draggable onDragEnd={(e) => {
                console.log("onDragEnd", e.latLng);
                onChangeMarkerPosition({ lat: e.latLng?.lat() ?? 0, lng: e.latLng?.lng() ?? 0 });
            }}/>
							</api_1.GoogleMap>

							{addresses && (<native_base_1.FlatList mt={89} mb={10} renderItem={renderItem} data={addresses} style={{ position: "absolute" }} bg="white" borderRadius={20} shadow={2}/>)}
						</native_base_1.VStack>)}
				</native_base_1.Modal.Body>
				<native_base_1.Modal.Footer>
					<native_base_1.Button onPress={onAcceptPressed}>Aceptar</native_base_1.Button>
				</native_base_1.Modal.Footer>
			</native_base_1.Modal.Content>
		</native_base_1.Modal>);
};
const AddressItem = ({ address, onPressed }) => {
    const onPressedInternal = () => {
        onPressed(address);
    };
    return (<native_base_1.Pressable onPress={onPressedInternal}>
			<native_base_1.HStack py={15} px={10} borderBottomColor={theme_1.Colors.colorVeryLightGray1} borderBottomWidth={0.4}>
				<native_base_1.Image source={icons_1.default.icMarker} w={15} h={15} mr={15}/>
				<native_base_1.Text flex={1}>{address?.fullAddr ?? ""}</native_base_1.Text>
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
exports.default = ModalRoadmapMap;
